import { AuthUI, createAuthUIInstances } from './authUI';
import { Notification } from '../notification/notfication';

export enum AuthType {
  Register,
  Login,
  RegisterComplete
}

class Auth {
  public constructor(private ui: AuthUI) {
    if (this.ui.getAuthType() === AuthType.Register || this.ui.getAuthType() === AuthType.RegisterComplete) {
      this.ui.onCountryChange();
    }

    this.ui.onSubmit(() => this.post());
  }

  /**
   * Post form data to API
   */

  private post() {
    // Suppress submitting the form if the terms and conditions
    // not accepted (only for registration)
    if (this.ui.getAuthType() === AuthType.Register && !this.ui.isLegalChecked()) {
      new Notification('danger', 'Ooops!', 'You have to accept our Terms and Conditions');
      return;
    }

    this.ui.enableLoading(true);
    const url: string = this.ui.url;

    // ReCAPTCHA only on OS2 (OS2.1 is already authenticated)
    if ((this.ui.getAuthType() === AuthType.Register || this.ui.getAuthType() === AuthType.Login) && window.googleRecaptchaKey) {
      grecaptcha.ready(() => {
        grecaptcha.execute(window.googleRecaptchaKey, {action: 'login'})
          .then((token) => {
            this.doPost(url, token);
          });
      });
    } else {
      this.doPost(url, '');
    }
  }

  private doPost(url: string, token: string) {
    $.ajax({
      url: url,
      type: 'POST',
      data: this.ui.getData(),
      headers: {
        'X-Recaptcha-Token': token
      }
    }).done(() => {
      // eslint-disable-next-line no-self-assign
      window.location = window.location;
    }).fail((error) => {
      const errorMsg = error.statusText == '' || !error.statusText ? 'Something went wrong' : error.responseJSON.message;
      new Notification('danger', 'Ooops!', errorMsg);
    }).always(() => {
      this.ui.enableLoading(false);
    });
  }
}

export function initAuth() {
  return createAuthUIInstances().map((ui: AuthUI) => {
    return new Auth(ui);
  });
}
